module.exports = __webpack_public_path__ + "assets/google-optimize.5f3fa747.svg";